"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeToken = decodeToken;
exports.tokenExpired = tokenExpired;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _jwtSimple = _interopRequireDefault(require("jwt-simple"));

var _BaseService2 = _interopRequireDefault(require("./BaseService"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TokensService = /*#__PURE__*/function (_BaseService) {
  (0, _inherits2["default"])(TokensService, _BaseService);

  var _super = _createSuper(TokensService);

  function TokensService() {
    (0, _classCallCheck2["default"])(this, TokensService);
    return _super.call(this, {});
  }

  (0, _createClass2["default"])(TokensService, [{
    key: "decodedIdToken",
    value: function decodedIdToken() {
      if (this.id) {
        return this.decode(this.id);
      }
    }
  }, {
    key: "decode",
    value: function decode(jwt) {
      return decodeToken(jwt);
    }
  }, {
    key: "refreshTokens",
    value: function () {
      var _refreshTokens = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var token;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.core.api.cognito.refreshToken(this.refresh);

              case 2:
                token = _context.sent;
                this.updateTokens(token);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshTokens() {
        return _refreshTokens.apply(this, arguments);
      }

      return refreshTokens;
    }()
  }, {
    key: "updateTokens",
    value: function updateTokens(tokens) {
      var mapToken = {
        id: tokens.id,
        access: tokens.access
      };

      if (tokens.refresh) {
        mapToken = _objectSpread({}, mapToken, {
          refresh: tokens.refresh
        });
      }

      this._tokenStore.updateTokens(mapToken);
    }
    /**
     *
     * Make sure id token is valid and if it isn't then refresh it
     */

  }, {
    key: "freshTokens",
    value: function () {
      var _freshTokens = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.expired()) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.refreshTokens();

              case 3:
                return _context2.abrupt("return", this);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function freshTokens() {
        return _freshTokens.apply(this, arguments);
      }

      return freshTokens;
    }()
  }, {
    key: "clear",
    value: function () {
      var _clear = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._tokenStore.clear();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function clear() {
        return _clear.apply(this, arguments);
      }

      return clear;
    }()
  }, {
    key: "expired",
    value: function expired() {
      var id = this.decodedIdToken();
      return !id || tokenExpired(id);
    }
  }, {
    key: "tokenStore",
    set: function set(tokenStore) {
      this._tokenStore = tokenStore;
    }
  }, {
    key: "id",
    get: function get() {
      if (!this._tokenStore) {
        return null;
      }

      return this._tokenStore.id;
    }
  }, {
    key: "refresh",
    get: function get() {
      if (!this._tokenStore) {
        return null;
      }

      return this._tokenStore.refresh;
    }
  }, {
    key: "access",
    get: function get() {
      if (!this._tokenStore) {
        return null;
      }

      return this._tokenStore.access;
    }
  }]);
  return TokensService;
}(_BaseService2["default"]);

exports["default"] = TokensService;

function decodeToken(token) {
  return _jwtSimple["default"].decode(token, null, true);
}
/**
 * Checks to see if a token is expired
 */


function tokenExpired(_ref) {
  var exp = _ref.exp;
  var currentTimestamp = Math.floor(Date.now() / 1000);
  return currentTimestamp >= exp;
}